import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import type { ListKeys } from '@src/constants/microcredits';
import { fetchMoreOffersAB } from '@src/reducers/microcredits';

export const useLoadRestOffers = (
  key: ListKeys,
  condition: boolean = true,
  features: { isSeaExcludeFeatureExperiment: boolean } = {
    isSeaExcludeFeatureExperiment: false,
  },
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (condition) {
      dispatch(fetchMoreOffersAB({ key, init: true, features }));
    }
  }, [dispatch, key, condition, features]);
};
